<template>
  <div>
    <template v-if="randomButtonData && randomButtonData.status !== RANDOM_BUTTON_STATUS.INACTIVE">
      <Transition name="page-transition" mode="out-in" appear>
        <div class="randomizer-page"  v-if="!showSpinner">
          <div class="randomizer-page_content">
            <div class="randomizer-page_tasklist-place">
              <TaskList :status="dataStatus" />
            </div>
            <div class="randomizer-page_card-place">
              <Card :status="dataStatus" />
            </div>
            <div class="randomizer-page_rewards">
              <h2 class="heading1">{{ $c('Награды, которые можно получить:') }}</h2>
              <RewardsList />
            </div>
          </div>
          <div class="randomizer-page_social-wrap">
            <div class="randomizer-page_social">
              <Social />
            </div>
          </div>
          <Transition name="page-transition" mode="out-in" appear>
            <PopUp
              v-if="popUpComponent"
              :pop-up-component="popUpComponent"
              :pop-up-valign="popUpValign"
              :pop-up-can-close="popUpCanClose"
            />
          </Transition>
        </div>
      </Transition>
      <Spinner class="app-spinner" size="large" color="red" v-if="showSpinner" />
    </template>
    <template v-else>
      <div class="randomizer_ended" v-html="$c('Акция «Миссия выполнима: Blitz-квест» недоступна.', { br: `<br>` })"></div>
    </template>
  </div>
</template>

<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import GameSwitcher from '@/components/GameSwitcher'
import TaskList from '@/components/RandomRewards/TaskList/TaskList'
import Card from '@/components/RandomRewards/Card/Card'
import RewardsList from '@/components/RandomRewards/Rewards/RewardsList'
import Social from '@/components/RandomRewards/Social/Social'
import PopUp from '@/components/RandomRewards/PopUp/PopUp'
import Spinner from '@/common/components/Spinner'
import BindCard from '@/components/RandomRewards/BindCard/BindCard'
import Quiz from '@/components/RandomRewards/Quiz/Quiz'
import UnknownError from '@/components/RandomRewards/UnknownError/UnknownError'
import { namespace, State } from 'vuex-class'

import { RANDOM_REWARDS_DATA_STATUS as DATA_STATUS, RANDOM_BUTTON_STATUS } from '@/constants'
import { ERROR_UNKNOWN } from '@/store/modules/random-rewards'

const cards = namespace('cards')
const auth = namespace('auth')
const randomRewards = namespace('randomRewards')

@Component({
  components: {
    GameSwitcher,
    TaskList,
    Card,
    RewardsList,
    Social,
    PopUp,
    Spinner,
    BindCard,
    Quiz,
    UnknownError
  }
})
class RandomRewards extends Vue {
  @cards.State('loading') cardsLoading
  @cards.State('cards') cards
  @cards.Action fetchCards

  @auth.State user
  @auth.State('requested') authRequested
  @auth.Action('authenticate') authenticateUser
  @auth.Getter isAuthorized
  @auth.Getter userID

  @randomRewards.Action('fetchTasks') fetchTasks
  @randomRewards.Action('fetchQuiz') fetchQuiz
  @randomRewards.Action('clearBindingCardError') clearBindingCardError
  @randomRewards.State('isParticipant') isParticipant
  @randomRewards.State('socialTasksExist') socialTasksExist
  @randomRewards.State('error') unknownError
  @State('randomButtonError') randomButtonError
  @State('randomButtonData') randomButtonData

  isLoading = true
  popUpComponent = null
  popUpValign = null
  popUpCanClose = true
  RANDOM_BUTTON_STATUS = RANDOM_BUTTON_STATUS

  created () {
    this.fetchInitData()
    this.$root.$on('randomRewardsBindCard', this.showCardBinding)
    this.$root.$on('closeRandomRewardsPopUp', this.closeRandomRewardsPopUp)
    this.$root.$on('randomRewardsOpenQuiz', this.openQuiz)
  }
  destroyed () {
    this.$root.$off('randomRewardsBindCard', this.showCardBinding)
    this.$root.$off('closeRandomRewardsPopUp', this.closeRandomRewardsPopUp)
    this.$root.$off('randomRewardsOpenQuiz', this.openQuiz)
  }
  get showSpinner () {
    return this.isLoading
  }
  get dataStatus () {
    if (this.isLoading) {
      return DATA_STATUS.DATA_NOT_READY
    }
    if (!this.isLoading && !this.isAuthorized) {
      return DATA_STATUS.NEED_AUTH
    }
    if (!this.isLoading && !this.isParticipant) {
      return DATA_STATUS.NEED_PARTICIPATE
    }
    return DATA_STATUS.DATA_READY
  }
  showCardBinding () {
    this.popUpValign = 'center'
    this.popUpCanClose = true
    this.popUpComponent = BindCard
  }
  openQuiz () {
    this.popUpValign = 'top'
    this.popUpCanClose = true
    this.popUpComponent = Quiz
  }
  closeRandomRewardsPopUp () {
    this.popUpComponent = null
    this.clearBindingCardError()
  }
  async fetchInitData () {
    try {
      this.error = null
      await this.authenticateUser(true)
      this.$analytics.sendUserAnalytics({ userID: this.userID })
      this.isAuthorized && await this.fetchCards({ include: ['accrual_sums'] })
      await this.fetchTasks()
      if (this.isParticipant) {
        await this.fetchQuiz()
      }
    } catch (error) {
      this.error = error
    }
    this.isLoading = false
  }
  @Watch('unknownError')
  interceptUnknownError () {
    if (this.unknownError === ERROR_UNKNOWN) {
      this.popUpValign = 'center'
      this.popUpCanClose = false
      this.popUpComponent = UnknownError
    }
  }
  @Watch('randomButtonError')
  interceptRandomButtonError () {
    if (this.randomButtonError !== null) {
      this.popUpValign = 'center'
      this.popUpCanClose = false
      this.popUpComponent = UnknownError
    }
  }
}

export default RandomRewards
</script>

<style lang="scss">
  .randomizer-page {
    position: relative;
    &_content {
      @extend %layout;
      display: grid;
      grid-template-areas: 'card'
                           'tasklist'
                           'rewards';
      grid-template-columns: 100%;
      grid-gap: 50px;
      margin-top: 60px;
      @include media_tablet {
        grid-gap: 25px;
        grid-template-columns: 50% 50%;
        grid-template-areas: 'tasklist card'
                           'rewards rewards';
      }
      @include media_desktop {
        grid-gap: 50px;
        grid-template-columns: 50% 50%;
        grid-template-areas: 'tasklist card'
                           'rewards rewards';
      }
    }
    &_social {
      @extend %layout;
      display: grid;
      grid-template-areas: 'social';
      grid-template-columns: 100%;
      grid-gap: 50px;
      @include media_tablet {
        padding-top: 60px;
      }
      &-wrap {
        width: 100%;
        margin-top: 48px;
        @include media_tablet {
          border-top: 1px solid #333;
          margin-top: 0;
        }
      }
    }
    &_tasklist-place {
      grid-area: tasklist;
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }
    &_card-place {
      grid-area: card;
    }
    &_rewards {
      grid-area: rewards;
      margin-top: 0;
      @include media_desktop {
        margin-top: 45px;
      }
    }
    .hgroup-line_wrapper {
      height: 72px;
    }
  }
  .randomizer-social {
    grid-area: social;
  }
  .ml20 {
    margin-left: 20px;
  }

  .randomizer_ended {
    text-align: center;
    padding: 40px 20px;
  }
</style>
